import type { ReactNode } from 'react';
import styled, { type CSSProperties } from 'styled-components';

import { SportBall } from '@sorare/core/src/atoms/icons/SportBall';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelXS } from '@sorare/core/src/atoms/typography';
import { Ellipsis } from '@sorare/core/src/atoms/typography/Ellipsis';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const StyledSportBall = styled(SportBall)`
  color: var(--color);
`;

type Props = { children: ReactNode; color?: string; iconOnly?: boolean };
export const BenchExtraUsedIn = ({ children, color, iconOnly }: Props) => {
  const { sport } = useSportContext();
  return (
    <Horizontal
      gap={0.5}
      center
      style={
        {
          '--color': color,
        } as CSSProperties
      }
    >
      <StyledSportBall sport={sport} size={1.5} />
      {!iconOnly && (
        <LabelXS>
          <Ellipsis>{children}</Ellipsis>
        </LabelXS>
      )}
    </Horizontal>
  );
};
